import PageMeta from "../../components/common/PageMeta";
import PageContainer from "../../components/common/PageContainer";
import PageHeader from "../../components/common/PageHeader";
import CdrnSettings from "./CdrnSettings";

export default function CdrnSettingsPage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | CDRN Settings"
        description="Chargemont | CDRN Settings"
      />
      <PageContainer>
        <PageHeader title="CDRN Settings" />
        <CdrnSettings />
      </PageContainer>
    </div>
  );
}
